/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModulePromo_browseContentModule = {
    readonly photo: string | null;
    readonly pillText: string | null;
    readonly headline: string | null;
    readonly subtext: string | null;
    readonly link: string | null;
    readonly linkText: string | null;
    readonly " $refType": "SbSharedContentModulePromo_browseContentModule";
};
export type SbSharedContentModulePromo_browseContentModule$data = SbSharedContentModulePromo_browseContentModule;
export type SbSharedContentModulePromo_browseContentModule$key = {
    readonly " $data"?: SbSharedContentModulePromo_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedContentModulePromo_browseContentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModulePromo_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "photo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pillText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkText",
      "storageKey": null
    }
  ],
  "type": "ContentModulePromo",
  "abstractKey": null
};
(node as any).hash = '3b15e045e642739f08f52ba6aebaf58b';
export default node;
